import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconYoutube$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconYoutube extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'ab4d26d1432b58efeeddb53597c2e2b2c54fb1c5', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'abc90a6998d5e9605bf88fbca62de745709e8366', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'eb9a76b7f4f01602185e79feb234984c5752d2bb', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M19.14 6.9a2.14 2.14 0 0 0-1.5-1.51A50 50 0 0 0 11 5a50 50 0 0 0-6.64.36 2.14 2.14 0 0 0-1.5 1.54 22.7 22.7 0 0 0-.35 4.1 22.6 22.6 0 0 0 .35 4.11 2.12 2.12 0 0 0 1.5 1.51c2.202.273 4.42.4 6.64.38a50 50 0 0 0 6.64-.36 2.12 2.12 0 0 0 1.5-1.51c.243-1.363.36-2.746.35-4.13a22.7 22.7 0 0 0-.35-4.1m-9.88 6.64v-5L13.7 11z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-youtube", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-youtube"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-youtube":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconYoutube$1);
            }
            break;
    } });
}

const CosmosIconYoutube = CosmosIconYoutube$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconYoutube, defineCustomElement };
